import { Helmet } from "react-helmet-async";

interface SEOProps {
    title?: string;
    description?: string;
    keywords?: string;
    image?: string;
}

const SITE_NAME = "Denny";
const SITE_URL = "https://denny.co.za";
const DEFAULT_IMAGE = `${SITE_URL}/denny-share.jpg`;

const DEFAULT_TITLE = "Denny | Savour the Flavour";

const DEFAULT_DESCRIPTION =
    "Discover delicious recipes, cooking inspiration, products and more from Denny. Savour the flavour with ideas for every meal and every occasion.";

const DEFAULT_KEYWORDS =
    "Denny, Denny South Africa, recipes, easy recipes, cooking inspiration, home cooking, meal ideas, sauces, cook-in sauces, pasta sauces, curry sauces, mushroom sauces, pour-over sauces, soups, stocks, mushrooms, plant-based, flavour, savour the flavour";

export default function SEO({
                                title = DEFAULT_TITLE,
                                description = DEFAULT_DESCRIPTION,
                                keywords = DEFAULT_KEYWORDS,
                                image = DEFAULT_IMAGE,
                            }: SEOProps) {
    return (
        <Helmet>
            {/* Primary */}
            <title>{title}</title>
            <meta name="description" content={description} />
            <meta name="keywords" content={keywords} />

            {/* Open Graph */}
            <meta property="og:type" content="website" />
            <meta property="og:site_name" content={SITE_NAME} />
            <meta property="og:title" content={title} />
            <meta property="og:description" content={description} />
            <meta property="og:image" content={image} />

            {/* Twitter */}
            <meta name="twitter:card" content="summary_large_image" />
            <meta name="twitter:title" content={title} />
            <meta name="twitter:description" content={description} />
            <meta name="twitter:image" content={image} />
        </Helmet>
    );
}
